import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestPackageGetList = () =>
    axios.get(`${apiUrl}package/list`);

export const requestPackageAdd = (data) =>
    axios.post(`${apiUrl}package`, data);

export const requestPackageAddImage = (id, file) => {
    const formData = new FormData();
    formData.append("image", file, file.filename);
    return axios.post(`${apiUrl}package/${id}/image`, formData);
};

export const requestPackageGetImage = (id) =>
    axios.get(`${apiUrl}package/${id}/image`, {
        responseType: "blob",
    });

export const requestPackageGetUnitsOfMeasurement = () =>
    axios.get(`${apiUrl}package/units-of-measurement`);

export const requestPackageAssign = (packageId, usersIdArr) =>
    axios.post(`${apiUrl}package/${packageId}/asign/batch`, usersIdArr);



// WEBPACK FOOTER //
// ./src/actions/package/requests.js